module.exports = __webpack_public_path__ + "static/media/peso.42880796.svg";